import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const SearchField = ({ onSearch, placeholder = "Search...", initialValue = "" }) => {
  const [searchValue, setSearchValue] = useState(initialValue);

  const handleSubmit = event => {
    event.preventDefault();
    onSearch(searchValue);
  };

  const handleClear = () => {
    setSearchValue("");
    onSearch("");
  };

  const handleKeyPress = event => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <TextField
        size="small"
        variant="outlined"
        placeholder={placeholder}
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
        onKeyPress={handleKeyPress}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {searchValue && (
                <IconButton size="small" onClick={handleClear} edge="end">
                  <ClearIcon />
                </IconButton>
              )}
              <IconButton size="small" type="submit" edge="end">
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{
          width: 280,
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            backgroundColor: "white",
            border: "1px solid",
            borderColor: "grey.300",
            boxShadow: "0 2px 4px rgba(0,0,0,0.04)",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              borderColor: "primary.300",
              boxShadow: "0 4px 8px rgba(0,0,0,0.08)",
            },
            "&.Mui-focused": {
              borderColor: "primary.500",
              boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
            },
          },
          "& .MuiOutlinedInput-input": {
            py: 1.5,
            px: 2,
            fontSize: "0.875rem",
            "&::placeholder": {
              color: "text.secondary",
              opacity: 0.8,
            },
          },
        }}
      />
    </Box>
  );
};

export default SearchField;
